import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { Col, Row } from 'antd';
import { useDispatch } from 'react-redux';
import InputMask from 'react-input-mask';
import { Link, useParams, useHistory } from 'react-router-dom';
import Box from '@iso/components/utility/box';
import Button from '@iso/components/uielements/button';
import notification from '@iso/components/Notification';
import bankAccountActions from '@iso/redux/bankAccount/actions';
import ContentHolder from '@iso/components/utility/contentHolder';
import LayoutWrapper from '@iso/components/utility/layoutWrapper';
import Input, { InputGroup, Textarea } from '@iso/components/uielements/input';
import Select, { SelectOption } from '@iso/components/uielements/select';
import Loader from '@iso/components/utility/loader';
import PageTitleBar from '@iso/components/utility/PageTitleBar';
import BankAccountPageWrapper, { Fieldset, Label } from './SingleBankAccount.styles';
import CustomInputSearch from '@iso/components/utility/customInputSearch.js';

import apiBankAccount from '@iso/services/repository/bankAccount';
import { onlyNumber, getBanksList } from '@iso/lib/helpers/utility';

const { updateBankAccount } = bankAccountActions

const Option = SelectOption;

export default function EditForm({ bankAccountId: idProp, onSaved, onCancel, inModal = false, footerEl = null } = {}) {
  const params = useParams();
  const bankAccountId = idProp !== undefined ? idProp : params.bankAccountId;
  const [load, setLoad] = useState(true);
  const [inputSearchString, setInputSearchString] = useState('Digite para buscar');
  const [allBanks, setAllBanks] = useState([]);
  const [options, setOptions] = useState([]);
  const [bankAccount, setBankAccount] = useState({ situation: 'Ativo', bankAccountType: 'CONTA_CORRENTE' });

  const dispatch = useDispatch();
  let history = useHistory();

  React.useEffect(() => {

    getBanksList().then(r => {
      setAllBanks(r);
      iterateBanks(r);
    });

    if (bankAccountId !== 0) {
      apiBankAccount
        .getBankAccountById(bankAccountId)
        .then((response) => {
          if (!response.data.error) {
            setInputSearchString(`${response.data.code} - ${response.data.bankName}`)
            setBankAccount(response.data)
          }
          else
            setBankAccount(prevState => {
              return { ...prevState, situation: 'Ativo' }
            })

          setLoad(false);
        })
        .catch((err) => {
          console.error("ops! ocorreu um erro" + err);
        });
    }
  }, [bankAccountId]);

  const iterateBanks = (data) => {
    let d = [];
    data.forEach(el => {
      if (el.code !== null && el.fullName !== null)
        d.push({
          'id': el.code,
          'ispb': el.ispb,
          'name': el.fullName,
          'label': `${el.code} - ${el.fullName}`,
          'normalized': `${el.code} - ${el.fullName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`
        })
    });
    setOptions(d)
  }

  const handleOnSelect = (item) => {
    setBankAccount(prevState => {
      return { ...prevState, code: item.id + '', ispb: item.ispb, bankName: item.name }
    });
  }

  function checkValues() {
    if (!bankAccount.name) {
      notification('error', 'Preencha o nome')
      return false;
    }
    if (!bankAccount.situation) {
      setBankAccount(prevState => {
        return { ...prevState, situation: 'Ativo' }
      });
    }

    return true;
  }

  // Função do botão Salvar
  const handleSubmit = () => {
    const continuar = checkValues(bankAccount);
    if (continuar === true) {
      (!(bankAccount.error) && typeof bankAccount._id !== "undefined" && bankAccount._id !== null) ?
        notification('success', 'Conta Bancária Salva') :
        notification('success', 'Conta Bancária Criada');
      dispatch(updateBankAccount(bankAccount));
      if (onSaved) onSaved(); else history.push('/dashboard/bank-account');
    }
  }

  const beforeMaskedValueChange = (newState, oldState, userInput) => {
    var { value } = newState;
    var selection = newState.selection;
    var cursorPosition = selection ? selection.start : null;

    // keep minus if entered by user
    if (value.endsWith('--') && userInput !== '--' && !this.state.value.endsWith('--')) {
      if (cursorPosition === value.length) {
        cursorPosition--;
        selection = { start: cursorPosition, end: cursorPosition };
      }
      value = value.slice(0, -1);
    }

    return {
      value,
      selection
    };
  }

    const actionButtons = (
    <>
{inModal ? (
          <Button color="primary" onClick={onCancel}>
            <span>Cancelar</span>
          </Button>
        ) : (
          <Link to="/dashboard/bank-account">
          <Button color="primary">
            <span>Cancelar</span>
          </Button>
        </Link>
        )}
        <Button type="primary" onClick={handleSubmit} className="saveBtn">
          <span>Salvar</span>
        </Button>
    </>
  );
  const actionsRender = footerEl ? (
    createPortal(actionButtons, footerEl)
  ) : (
    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, padding: '10px 4px 20px' }}>
      {actionButtons}
    </div>
  );
return (load) ? <Loader /> : (
    <LayoutWrapper>
      {inModal ? null : (
        <PageTitleBar title={`${bankAccount._id ? 'Editar' : 'Cadastrar'} Conta Bancária`} backTo="/dashboard/bank-account" />
      )}
      {actionsRender}
      <Box style={{ border: 'none', boxShadow: 'none' }}>
        <BankAccountPageWrapper className="editView">
          <div className="PageContent">
            <Box className="productTabsBox" style={{ border: 'none', boxShadow: 'none', padding: 0, background: 'transparent' }} title={<div id="forms.BankAccount.verticalTitle" />}>
              <ContentHolder>
                <InputGroup size="large" style={{ marginBottom: '15px' }}>
                  <Row gutter={24}>
                    <Col span={6}>
                      <Fieldset>
                        <Label>Nome de identificação da conta*</Label>
                        <Input
                          placeholder="Nome"
                          value={bankAccount?.name}
                          name="name"
                          onChange={(e) => {
                            setBankAccount(prevState => {
                              return { ...prevState, name: e.target.value }
                            });
                          }}
                          className="BillFormTitle"
                        />
                      </Fieldset>
                    </Col>
                    <Col span={6}>
                      <Fieldset>
                        <Label>Nome do titular*</Label>
                        <Input
                          placeholder="Nome do titular"
                          value={bankAccount?.ownerName}
                          name="ownerName"
                          onChange={(e) => {
                            setBankAccount(prevState => {
                              return { ...prevState, ownerName: e.target.value }
                            });
                          }}
                          className="BillFormTitle"
                        />
                      </Fieldset>
                    </Col>
                    <Col span={6}>
                      <Fieldset>
                        <Label>CPF/CNPJ do titular*</Label>
                        <InputMask
                          name='cpfCnpj'
                          maskChar={''}
                          className='ant-input'
                          value={(bankAccount?.cpfCnpj) ? bankAccount?.cpfCnpj : undefined}
                          mask={onlyNumber(bankAccount?.cpfCnpj).length < 12 ? "999.999.999-999" : "99.999.999/9999-99"}
                          onChange={(e) => {
                            setBankAccount(prevState => {
                              return { ...prevState, cpfCnpj: e.target.value }
                            })
                          }}
                          beforeMaskedValueChange={beforeMaskedValueChange}
                        />
                      </Fieldset>
                    </Col>
                    <Col span={6}>
                      <Fieldset>
                        <Label>Tipo de conta*</Label>
                        <Select
                          value={(typeof (bankAccount?.bankAccountType) !== 'undefined') ? bankAccount?.bankAccountType : 'CONTA_CORRENTE'}
                          onChange={(e) => {
                            setBankAccount(prevState => {
                              return { ...prevState, bankAccountType: e }
                            });
                          }}
                        >
                          <Option key="CONTA_CORRENTE" value="CONTA_CORRENTE">Conta Corrente</Option>
                          <Option key="CONTA_POUPANCA" value="CONTA_POUPANCA">Conta Poupança</Option>
                        </Select>
                      </Fieldset>
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={8}>
                      <Fieldset>
                        <Label>Banco*</Label>
                        <CustomInputSearch
                          items={options}
                          onSelect={handleOnSelect}
                          placeholder={inputSearchString}
                          className="reactSearch"
                        />
                      </Fieldset>
                    </Col>
                    <Col span={4}>
                      <Fieldset>
                        <Label>Agência sem dígito*</Label>
                        <Input
                          defaultValue={bankAccount?.agency}
                          onChange={(e) => {
                            setBankAccount(prevState => {
                              return { ...prevState, agency: e.target.value }
                            });
                          }}
                        />
                      </Fieldset>
                    </Col>
                    {/* <Col span={2}>
                      <Fieldset>
                        <Label>Dígito da agência</Label>
                          <Input
                            defaultValue={bankAccount?.agency_digit}
                            onChange={(e) => {
                              setBankAccount(prevState => {
                                return { ...prevState, agency_digit: e.target.value }
                              });
                            }}
                          />
                      </Fieldset>
                    </Col> */}
                    <Col span={4}>
                      <Fieldset>
                        <Label>Conta</Label>
                        <Input
                          defaultValue={bankAccount?.account}
                          onChange={(e) => {
                            setBankAccount(prevState => {
                              return { ...prevState, account: e.target.value }
                            });
                          }}
                        />
                      </Fieldset>
                    </Col>
                    <Col span={2}>
                      <Fieldset>
                        <Label>Dígito da conta</Label>
                        <Input
                          defaultValue={bankAccount?.account_digit}
                          onChange={(e) => {
                            setBankAccount(prevState => {
                              return { ...prevState, account_digit: e.target.value }
                            });
                          }}
                        />
                      </Fieldset>
                    </Col>
                    <Col span={6}>
                      <Fieldset>
                        <Label>Situação*</Label>
                        <Select
                          value={(typeof (bankAccount?.situation) !== 'undefined') ? bankAccount?.situation : 'Ativo'}
                          onChange={(e) => {
                            setBankAccount(prevState => {
                              return { ...prevState, situation: e }
                            });
                          }}
                        >
                          <Option key="Ativo" value="Ativo">Ativo</Option>
                          <Option key="Inativo" value="Inativo">Inativo</Option>
                        </Select>
                      </Fieldset>
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span="8">
                      <Fieldset>
                        <Label>Informe a chave PIX caso exista</Label>
                        <Input
                          onChange={(e) => {
                            setBankAccount(prevState => {
                              return { ...prevState, pixAddressKey: e.target.value }
                            });
                          }}
                          type={'text'}
                          name="pixAddressKey"
                          value={bankAccount?.pixAddressKey}
                        />
                      </Fieldset>
                    </Col>
                    <Col span={4} className="contentInput">
                      <Fieldset>
                        <Label>Tipo da chave PIX</Label>
                        <Select
                          value={bankAccount?.pixAddressKeyType}
                          placeholder="Selecione a opção"
                          onChange={(e) => {
                            setBankAccount(prevState => {
                              return { ...prevState, pixAddressKeyType: e }
                            });
                          }}
                        >
                          <Option key={'CPF'} value={'CPF'}>CPF</Option>
                          <Option key={'CNPJ'} value={'CNPJ'}>CNPJ</Option>
                          <Option key={'EMAIL'} value={'EMAIL'}>E-mail</Option>
                          <Option key={'PHONE'} value={'PHONE'}>Telefone</Option>
                          <Option key={'EVP'} value={'EVP'}>Chave aleatória</Option>
                        </Select>
                      </Fieldset>
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={24}>
                      <Fieldset>
                        <Label>Descrição</Label>
                        <Textarea
                          value={(bankAccount?.description) ? bankAccount?.description : ''}
                          style={{ height: '150px' }}
                          onChange={(e) => { setBankAccount(prevState => { return { ...prevState, description: e.target.value } }) }}
                        />
                      </Fieldset>
                    </Col>
                  </Row>
                </InputGroup>
              </ContentHolder>
            </Box>
          </div>
        </BankAccountPageWrapper>
      </Box>
    </LayoutWrapper>
  );
}